import { orderBy } from 'lodash';
import { RECENTLY_VIEWED_MAX_DAYS } from '../constants';
import { getDateWithoutTime } from './dateUtils';
import { getLocalStorageJson, setLocalStorageJson } from './localStorage';

export const filterDataByDate = (data, key, days) => {
  const sortedData = orderBy(data, [key], ['desc']);
  let totalDays = 0;
  const filteredData = [];

  for (let i = 0; i < sortedData.length; i += 1) {
    if (totalDays === days) break;
    filteredData.push(sortedData[i]);
    if (
      sortedData[i + 1] &&
      getDateWithoutTime(sortedData[i][key]) >
        getDateWithoutTime(sortedData[i + 1][key])
    ) {
      totalDays += 1;
    }
  }
  return filteredData;
};

export const updateRecentlyViewed = (
  recentlyViewedKey,
  id,
  type,
  name,
  contractCode,
  org,
  url,
  category = '',
  siteName = '',
  userGroup = '',
  subscriptionStartDate,
  subscriptionEndDate,
  orgName,
  city,
  state,
  zip,
) => {
  const recentlyViewed = getLocalStorageJson(recentlyViewedKey, []) || [];

  const index = recentlyViewed.findIndex(
    value => value.id === id && value.contractCode === contractCode,
  );

  const viewedData = {
    userGroup,
    id,
    type,
    name,
    category,
    siteName,
    contractCode,
    contract: org ? `${contractCode}, ${org}` : contractCode,
    url,
    lastViewed: new Date().getTime(),
    subscriptionStartDate,
    subscriptionEndDate,
    org: orgName || org,
    city,
    state,
    zip,
  };

  if (index > -1) recentlyViewed[index] = viewedData;
  else recentlyViewed.push(viewedData);

  // Removing old key, this line can be remove later
  localStorage.removeItem(recentlyViewedKey.replace('pai:', 'lc:'));

  setLocalStorageJson(
    recentlyViewedKey,
    filterDataByDate(recentlyViewed, 'lastViewed', RECENTLY_VIEWED_MAX_DAYS),
  );
};
